import CurrencyFormatInput from "./CurrencyFormatInput";

export default CurrencyFormatInput;
